<template>
  <!--运动员管理-->
  <div class="bg-gray">
    <div class="box-content">
      <div class="box-operate">
        <el-button type="primary" icon="el-icon-plus" @click="addShow = true">新增教练员</el-button>
      </div>
<!--      <el-tabs v-model="active" @tab-click="onStatusChange">-->
<!--        <el-tab-pane label="正常" name="0"></el-tab-pane>-->
<!--        <el-tab-pane label="隐藏" name="1"></el-tab-pane>-->
<!--      </el-tabs>-->
      <el-table :data="list" ref="table" :show-header="false">
        <!--        <el-table-column type="index" label="序号" width="56" align="center"></el-table-column>-->
        <el-table-column prop="name" label="用户名" min-width="140">
          <template slot-scope="scope">
            {{scope.row.name}}
            <el-tag round size="small" v-if="scope.row.cert_status==1" type="success" effect="dark">已认证</el-tag>
            <el-tag round size="small" v-else-if="scope.row.cert_status==3" effect="dark">认证失败</el-tag>
            <el-tag round size="small" v-else-if="scope.row.cardtype==1 && scope.row.cert_status==2" type="warning" effect="dark">未认证</el-tag>
            <el-tag round size="small" plain v-else-if="scope.row.cardtype!=1 && scope.row.cert_status==2">无需认证</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="num" label="身份证号" min-width="100"></el-table-column>
        <el-table-column
            align="right">
          <template slot-scope="scope">
<!--            <el-popconfirm-->
<!--                title="是否隐藏该运动员？"-->
<!--                v-if="scope.row.is_show == 1"-->
<!--                @confirm="handleHide(scope.$index, scope.row)"-->
<!--            >-->
<!--              <el-button-->
<!--                  size="medium"slot="reference">隐藏</el-button>-->
<!--            </el-popconfirm>-->

<!--            <el-button-->
<!--                size="medium"-->
<!--                type="primary"-->
<!--                v-if="scope.row.is_show != 1"-->
<!--                @click="handleShow(scope.$index, scope.row)">显示</el-button>-->
            <el-button
                size="medium"
                type="primary"
                v-if="scope.row.cert_status ==2"
                @click="handleCert(scope.$index, scope.row)">认证</el-button>
          </template>
        </el-table-column>

<!--        <p slot="append" style="text-align:center; line-height:50px;" v-if="params.pageNo < row.totalpage && list.length > 0" @click="onLoad">-->
<!--          <el-link>点击加载更多</el-link>-->
<!--        </p>-->
      </el-table>
      <div class="table-pagination">
        <el-pagination
            background
            @current-change="handleCurrentChange" :current-page="row.currentpage"
            :page-size="params.pageSize" layout="total, prev, pager, next"
            :total="row.total">
        </el-pagination>

      </div>
    </div>
    <el-dialog title="新增教练员" class="dialog-content" :visible.sync="addShow" @close="addShow = false">
      <el-form
          :model="formData"
          ref="ruleForm"
          :rules="rules"
          label-width="100px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input
                  type="text"
                  placeholder="请输入姓名"
                  v-model="formData.name"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件类型" prop="type">
              <el-radio-group v-model="formData.cardtype">
                <el-radio :label="1">身份证</el-radio>
                <el-radio :label="2">护照</el-radio>
                <el-radio :label="3">其他身份证明</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="num" v-if="formData.cardtype==1">
              <el-input
                  type="text"
                  placeholder="请输入身份证号"
                  v-model="formData.num"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.cardtype!=1">
            <el-form-item label="证件号码" prop="huzhao">
              <el-input
                  type="text"
                  placeholder="请输入证件号码"
                  v-model="formData.huzhao"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phone">
              <el-input
                  type="text"
                  placeholder="请输入手机号"
                  v-model="formData.phone"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input
                  type="text"
                  placeholder="请输入邮箱"
                  v-model="formData.email"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="QQ" prop="qq">
              <el-input
                  type="text"
                  placeholder="请输入QQ"
                  v-model="formData.qq"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="微信号" prop="weixin">
              <el-input
                  type="text"
                  placeholder="请输入微信号"
                  v-model="formData.weixin"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">保存
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<style scoped>

</style>
<script>
import Vue from "vue";
import { PullRefresh, List, Toast, Sticky, Overlay } from "vant";
import validator from "../../../utils/validator";
Vue.use(PullRefresh)
    .use(Toast)
    .use(Sticky)
    .use(Overlay);
export default {
  name: "YundongyuanList",
  components: {
    [List.name]: List
  },
  data: function() {
    return {
      copy_text:'',
      show_share_panel:false,
      isLoading: false,
      loading: false,
      finished: false,
      actionShow: false,
      addShow: false,
      saveLoading: false,
      list: [],
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2015, 0, 1),
      showNumTypePicker: false,
      numTypeColumns: ['身份证', '护照', '其他身份证明'],
      actions: [
        {name: '隐藏'},
        {name: '认证'},
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      params: {
        pageNo: 1,
        pageSize: 10,
        keywords: '',
        cate_id: 0,
        is_show: 1
      },
      rules: {
        name: [{ required: true, message: "请输入单位名称", trigger: "blur" }],
        namekey: [{ required: true, message: "请选择省市", trigger: "blur" }],
        area: [{ required: true, message: "请选择地区", trigger: "blur" }],
        address: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
        nickname: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        num: [
          { required: true, message: "请输入正确的身份证号", trigger: "blur" },
          { validator: validator.idCard, trigger: "blur" },
        ],
        huzhao: [
          { required: true, message: "证件号码不能为空", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入正确的手机号", trigger: "blur" },
          { validator: validator.phone, trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入正确的邮箱", trigger: "blur" },
          { validator: validator.email, trigger: "blur" },
        ],
      },
      formData:{
        name:'',
        num:'',
        huzhao:'',
        cardtype:1,
        numTypeName:'身份证',
        phone:'',
        email:'',
        qq:'',
        weixin:'',
      },
      active: 0,
      row: {}
    };
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "教练员管理"
    that.list = [];
    that.active = 0;
    that.params.pageNo = 1;
    that.loading = true;
    that.finished = false;
    that.getList();
  },
  watch: {},
  destroyed() {},
  methods: {
    getList() {
      let that = this;
      that.$api.get('/api/jiaolian/jiaolianList', that.params, (res) => {
        that.loading = false;

        if (res.data.currentpage == 1) {
          that.isLoading = false;
          that.list = res.data.list
        } else {
          let list = that.list.concat(res.data.list);

          that.list = list;
        }

        if (res.data.list.length == 0) {
          that.finished = true;
        }
        that.params.pageNo += 1;
        that.row = res.data
      })
    },

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.params.pageNo = val
      this.list = []
      this.getList()
    },

    handleHide(index, row) {
      let that = this
      that.$api.post('/api/yundongyuan/hide', {
        id: row.id
      }, (res) => {
        that.onRefresh();
      }, (res) => {
        this.$message.error(res.msg);
      })
    },

    handleShow(index, row) {
      let that = this
      that.$api.post('/api/jiaolian/show', {
        id: row.id
      }, (res) => {
        that.onRefresh();
      }, (res) => {
        this.$message.error(res.msg);
      })
    },

    // 认证
    handleCert(index, row) {
      let that = this
      that.$api.post('/api/jiaolian/cert', {
        id: row.id
      }, (res) => {
        that.onRefresh();
      }, (res) => {
        this.$message.error(res.msg);
      })
    },

    submitForm(formName) {
      const that = this;
      console.log(that.formData)
      // numTypeName 与birthday的值不对

      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.saveLoading = true;
          that.$api.post("/api/jiaolian/add", that.formData, (res) => {
            that.saveLoading = false;
            that.addShow = false;
            that.onRefresh();
            that.formData = {
              name:'',
              num:'',
              huzhao:'',
              cardtype:1,
              numTypeName:'身份证',
              phone:'',
              email:'',
              qq:'',
              weixin:'',
            };
          }, (rs) => {
            that.$message.error(rs.msg)
            that.saveLoading = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.getList();
    },
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log("this.params.pageNo");

      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.getList();
        }, 500);
      }
    },

    // 更改状态
    onStatusChange(tab, event) {
      console.log('onStatusChange',tab, event)
      // return
      let that = this;
      that.params.is_show = parseInt(tab.name) + 1;
      that.params.pageNo = 1;

      // 激活下拉
      that.finished = false;
      that.loading = true;
      that.list = [];

      this.$route.query.is_show = 0;
      that.getList();
    },
    shareWeixinFriend(){
      console.log('shareWeixinFriend')
      let that = this;
      if(window.isApp()){
        appEvent({
          name: 'shareWeixinFriend',
          query: that.share_data
        });
      }else{
        this.showWxShare = true;
        this.show_share_panel = false;
      }
    },
    shareWeixinTimeLine(){
      let that = this;
      if(window.isApp()){
        appEvent({
          name: 'shareWeixinTimeLine',
          query: that.share_data
        });
      }else{
        this.showWxShare = true;
        this.show_share_panel = false;

      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// JiaolianList.vue?0e415919